import React, {useState, useEffect, useRef} from 'react';
import { Alert, Platform, ScrollView, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../styles/tailwind';
import Text from '../../../components/Text';
import BottomSheet from '../../../components/BottomSheet';
import Input from '../../../components/Forms/Input';
import { useForm } from 'react-hook-form';
import IconButton from '../../../components/IconButton';
import useFormSubmit from '../../../hooks/useFormSubmit';
import { ColorSelector, vehicleColors as _vehicleColors } from '../Admin/Units/NewVehicleModal';
import Icon from '../../../components/IcomoonIcon';
import api from '../../../utils/api';
import { useToast } from 'react-native-toast-notifications';

export const vehicleColors = _vehicleColors

export default function VehiclesModal({ onRequestClose, visible, communityId, unitId, onVehicleCreated, onVehicleDeleted, vehicles }) {
  const { control, handleSubmit, reset, setValue } = useForm();
  const [deletingVehicleId, setDeletingVehicleId] = useState(null);
  const toast = useToast();

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onVehicleCreated,
    onError: (error) => { },
    successToastMessage: "Vehículo creado",
    endpoint: `/communities/${communityId}/units/${unitId}/vehicles`,
  })

  useEffect(() => {
    reset({})
  }, [visible]);

  const deleteVehicle = (vehicleUuid: string) => {
    setDeletingVehicleId(vehicleUuid);
    api.delete(`/communities/${communityId}/units/${unitId}/vehicles/${vehicleUuid}`)
      .then(() => {
        toast.show("Vehículo eliminado");
        onVehicleDeleted?.();
      })
      .catch((error) => {
        alert(error.response?.data?.message || "Error al eliminar");
      })
      .finally(() => {
        setDeletingVehicleId(null);
      });
  };

  const confirmVehicleDeletion = (vehicle) => {
    if (Platform.OS === "web") {
      if (confirm(`¿Eliminar ${vehicle.brand}?\nEsta acción no podrá deshacerse`)) {
        deleteVehicle(vehicle.uuid);
      }
    } else {
      Alert.alert(
        '¿Eliminar vehículo?',
        `${vehicle.brand} será eliminado. Esta acción no podrá deshacerse`,
        [
          { text: 'Cancelar', style: 'cancel' },
          { text: 'Eliminar', style: 'destructive', onPress: () => deleteVehicle(vehicle.uuid) },
        ]
      );
    }
  };


  const hasVehicles = vehicles.length > 0
  const height = (630 + vehicles.length * 80)
  const scrollRef = useRef()

  return (
    <BottomSheet onRequestClose={onRequestClose} visible={visible} height={height}>
      <View style={tw`bg-secondary pt-6 pb-4`}>
        <View style={tw`pl-10 mb-4`}>
          <Text style={tw`text-lg font-500 text-white `}>Registrar vehículo</Text>

          <TouchableOpacity style={tw`absolute right-7`} onPress={onRequestClose}>
            <Icon name='close' color={tw.color('white')} size={26} />
          </TouchableOpacity>
        </View>

        {/* Vehicles list */}
        {
          hasVehicles &&
          <View style={tw`bg-gray-100 mx-3 border border-gray-200 rounded-xl`}>
            {
                vehicles.map((vehicle, i) => {
                  const vehicleColor = vehicleColors.find(color => color.name == vehicle.color)
                  
                  return (
                    <View
                      key={vehicle.uuid}
                      style={tw.style(`row justify-between border-b border-gray-200 px-5 py-3`, (i + 1) == vehicles.length && `border-b-0`)}
                    >
                      <View style={tw`flex-1`}>
                        <View style={tw`row items-start`}>
                          {
                            vehicleColor &&
                              <View style={tw`h-4 w-4 border-gray-200 border rounded-full mr-2 mt-1 bg-[${vehicleColor.hex}]`}></View>
                          }

                          <View style={tw``}>
                            <Text style={tw``}>{vehicle.brand} {vehicle.model} {vehicle.year}</Text>
                            <Text style={tw`text-gray-400`}>{vehicle.plate_number}</Text>
                          </View>
                        </View>
                      </View>

                      <TouchableOpacity
                        onPress={() => confirmVehicleDeletion(vehicle)}
                        disabled={deletingVehicleId === vehicle.uuid}
                        style={tw.style(deletingVehicleId === vehicle.uuid && 'opacity-30')}
                      >
                        <Icon
                          name='close'
                          color={tw.color('red')}
                          size={20}
                        />
                      </TouchableOpacity>
                    </View>
                  )
                })
            }
          </View>
        }
      </View>


      <ScrollView ref={scrollRef} style={tw`flex-1`} contentContainerStyle={tw`pt-5 px-5 pb-40`} keyboardShouldPersistTaps='handled'>
        <Text style={tw`text-lg font-500 text-secondary mb-4`}>Agregar vehículo</Text>

        {/* Marca/Modelo */}
        <View style={tw`mb-3`}>
          <Text style={tw`text-gray-500 mb-2`}>Marca / Modelo</Text>

          <Input control={control} name='brand' rules={{required: true}} />
        </View>


        {/* Color */}
        <View style={tw`mb-8`}>
          <ColorSelector onChange={(value) => setValue("color", value)} />
        </View>


        {/* Placas */}
        <View style={tw`mb-0`}>
          <Text style={tw`text-gray-500 mb-2`}>Placas</Text>

          <Input
            control={control}
            name='plate_number'
            onFocus={() => setTimeout(() => scrollRef.current?.scrollToEnd({ animated: true }), 150)}
          />
        </View>
      </ScrollView>

      <IconButton
        disabled={isSubmitting}
        title={isSubmitting ? "Guardando" : "Guardar vehículo"}
        style={tw`rounded-b-0 rounded-3xl py-3`}
        onPress={handleSubmit(submitForm)}
      />
    </BottomSheet>
  );
}
